import loadable from '@loadable/component';

export { SearchBarProvider, useSearchBarContext } from './SearchBarContext';

export const SearchBar = loadable(() => import('./components/SearchBarLazy'));
